import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import i18n from './assets/utils/i18n'
import "babel-polyfill"
import $ from 'jquery'
import 'bootstrap'
import ElementUI from 'element-ui'
import animated from 'animate.css'
import 'swiper/css/swiper.min.css'


import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview, {
    bgOpacity: 0.5,
    closeOnScroll: false,
    maxSpreadZoom:2,
    fullscreenEl: false,
    tapToToggleControls:false,
    zoomEl: false,
    captionEl:false,
    shareEl:false,
    preloaderEl:false,
    counterEl: false,
    // clickToCloseNonZoomable:false,
})
Vue.use(ElementUI)

Vue.config.productionTip = false


window.eventBus = new Vue();
// var mixins = {
//     created: function() {
//         let query = this.$route.query
//         if (query.lang) {
//             if (query.lang == 'EN') {
//                 console.log('设置英文')
//                 this.$i18n.locale = 'EN'
//                 this.$store.dispatch('setLang', query.lang)
//             } else {
//                 console.log('设置中文')
//                 this.$i18n.locale = 'CN'
//                 this.$store.dispatch('setLang', query.lang)
//             }
//         }
//     }
// }

/* eslint-disable no-new */
new Vue({
    // mixins: [mixins],
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>',
    methods: {
        setLang() {
            // 获取路由参数
            let query = this.$route.query
            if (query.lang) {
                if (query.lang == 'EN') {
                    this.$i18n.locale = 'EN';
                    this.$store.dispatch('setLang', query.lang)
                } else {
                    this.$i18n.locale = 'CN'
                    this.$store.dispatch('setLang', query.lang)
                }
            }
        }
    }
})



// WEBPACK FOOTER //
// ./src/main.js